/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React from "react";
import "./styles.scss";

interface GuestCardProps {
  guest?: GuestProps;
}

export interface GuestProps {
  id?: number;
  name?: string;
  title?: string;
  image?: string;
  organization?: string;
}

export const GuestCard = (props: GuestCardProps): JSX.Element => {
  const { guest } = props;
  return (
    <>
      {guest && (
        <div className="gi">
          <img src={guest.image} alt={`guest-${guest.name}`} />
          <div className="gi-info">
            <h6>{guest.name}</h6>
            <p>
              {guest.title}, {guest.organization}
            </p>
          </div>
        </div>
      )}
    </>
  );
};
GuestCard.defaultProps = {
  guest: { id: 0, name: "", title: "", image: "" },
};
